// Mood Board Color
export const BG_PRIMARY = '#F0EDE6'; // Warna Chreme Muda
export const BG_SECONDARY = '#EDE0D1'; // Warna Chreme Yang Lebih Tua
export const BG_ALTERNATIVE = '#B18F68'; // Warna Ketiga Coklat Tua
// Text Color
export const TEXT_PRIMARY = '#100F0D'; // Warna Hitam Body
export const TEXT_SECONDARY = '#100F0D'; // Warana Coklat Muda
export const TEXT_ALTERNATIVE = '#B18F68'; // Alternative Color
export const TEXT_BUTTON = '#F0EDE6';

// Music & Navigation Color
export const NAVIGATION_COLOR = BG_ALTERNATIVE; // Warna BG
export const ICON_NAVIGATION_COLOR = 'white'; // Warna Iconnya

// Default Button Color
export const BUTTON_PROPS = {
  _active: { borderColor: 'transparent' },
  _hover: { borderColor: 'transparent' },
  _focus: { borderColor: 'transparent' },
};

export const DEFAULT_BUTTON_PROPS = {};
